import { render, staticRenderFns } from "./PiecesPopup.vue?vue&type=template&id=1acea460&scoped=true&"
import script from "./PiecesPopup.vue?vue&type=script&lang=js&"
export * from "./PiecesPopup.vue?vue&type=script&lang=js&"
import style0 from "./PiecesPopup.vue?vue&type=style&index=0&id=1acea460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acea460",
  null
  
)

export default component.exports